import React, { useState } from "react"
import { Col, Container, Modal, Row } from "react-bootstrap"
import { useTranslation } from "react-i18next"

import AdminUsersComponent from "./AdminUsersComponent"
import Settings from "../Settings/Settings"
import AdminOrganizationsComponent from "./AdminOrganizationsComponent"
import AdminExtranjerosHaitianosComponent from "./AdminExtranjerosHaitianosComponent"
import AdminFichadosComponent from "./AdminFichadosComponent"
import AdminDGIIComponent from "./AdminDGIIComponent"

import AdminDeportadosComponent from "./AdminDeportadosComponent"
import AdminComplicesComponent from "./AdminComplicesComponent"
import AdminEstructuraComponent from "./AdminEstructuraComponent"
import AdminDesaparecidosComponent from "./AdminDesaparecidosComponent"
import AdminExtraditadosComponent from "./AdminExtraditadosComponent"
import AdminCeduladosComponent from "./AdminCeduladosComponent"
import AdminLitigioComponent from "./AdminLitigioComponent"
import AdminEmpresasRASADEPComponent from "./AdminEmpresasRASADEPComponent"
import AdminVerificarAntecedentesFilterFields from "./AdminVerificarAntecedentes.filterFields"
import AdminVerificarAntecedentes from "./AdminVerificarAntecedentes"
import AdminDashboardComponent from "./AdminDashboardComponent"

function AdminContainerModal(props) {
  const { t } = useTranslation("global")
  const [section, setSection] = useState<string>("dashboard")
  return (
    <Modal
      show={true}
      onHide={props.toggle}
      size={"xl"}
      className={props.cssClass}
    >
      <Modal.Header closeButton>
        <Modal.Title>{props.title}</Modal.Title>

      </Modal.Header>
      <Modal.Body>
        <Container >
          <Row>
            <Col xs={12} md={4} lg={3}>
              <div className="my-4 bg-white shadow-sm border-end px-2 py-2">
                <h5>Menu</h5>
                <hr className="text-light bg-light" />
                <ul className="list-unstyled">
                  <li
                    className={
                      `clickable  border-bottom py-2 px-2 mb-2 ` +
                      (section === "dashboard" ? "active" : "")
                    }
                    onClick={() => setSection("dashboard")}
                  >Dashboard</li>
                  <li
                    className={
                      `clickable  border-bottom py-2 px-2 mb-2 ` +
                      (section === "dgii" ? "active" : "")
                    }
                    onClick={() => setSection("dgii")}
                  >
                    Empresas/RNC
                  </li>
                  {/* <li
                className={
                  `clickable  border-bottom py-2 px-2 mb-2 ` +
                  (section === "detenidos" ? "active" : "")
                }
                onClick={() => setSection("detenidos")}
              >
                Detenidos
              </li> */}
                  {/* <li
                className={
                  `clickable  border-bottom py-2 px-2 mb-2 ` +
                  (section === "centrosDetenidos" ? "active" : "")
                }
                onClick={() => setSection("centrosDetenidos")}
              >
                Centros - Detenidos
              </li> */}
                  <li
                    className={
                      `clickable  border-bottom py-2 px-2 mb-2 ` +
                      (section === "identidades" ? "active" : "")
                    }
                    onClick={() => setSection("identidades")}
                  >
                    Identidades
                  </li>
                  <li
                    className={
                      `clickable  border-bottom py-2 px-2 mb-2 ` +
                      (section === "deportados" ? "active" : "")
                    }
                    onClick={() => setSection("deportados")}
                  >
                    Deportados
                  </li>

                  <li
                    className={
                      `clickable  border-bottom py-2 px-2 mb-2 ` +
                      (section === "desaparecidos" ? "active" : "")
                    }
                    onClick={() => setSection("desaparecidos")}
                  >
                    Desaparecidos
                  </li>
                  <li
                    className={
                      `clickable  border-bottom py-2 px-2 mb-2 ` +
                      (section === "extraditados" ? "active" : "")
                    }
                    onClick={() => setSection("extraditados")}
                  >
                    Extradictados
                  </li>
                  <li
                    className={
                      `clickable  border-bottom py-2 px-2 mb-2 ` +
                      (section === "fichados" ? "active" : "")
                    }
                    onClick={() => setSection("fichados")}
                  >
                    Fichados
                  </li>
                  <li
                    title="Persona Asociada a un Delito Precedente"
                    className={
                      `clickable  border-bottom py-2 px-2 mb-2 text-red` +
                      (section === "complices" ? "active" : "")
                    }
                    onClick={() => setSection("complices")}
                  >
                    PADEP
                  </li>
                  <li
                    className={
                      `clickable  border-bottom py-2 px-2 mb-2 ` +
                      (section === "extranjerosHaitianos" ? "active" : "")
                    }
                    onClick={() => setSection("extranjerosHaitianos")}
                  >
                    Extranjeros
                  </li>
                  <li
                    className={
                      `clickable  border-bottom py-2 px-2 mb-2 ` +
                      (section === "estructuras" ? "active" : "")
                    }
                    onClick={() => setSection("estructuras")}
                  >
                    Estructuras Delictivas/Casos
                  </li>
                  <li
                    className={
                      `clickable  border-bottom py-2 px-2 mb-2 ` +
                      (section === "litigio" ? "active" : "")
                    }
                    onClick={() => setSection("litigio")}
                  >
                    Litigios
                  </li>
                  <li
                    className={
                      `clickable  border-bottom py-2 px-2 mb-2 ` +
                      (section === "cedulados" ? "active" : "")
                    }
                    onClick={() => setSection("cedulados")}
                  >
                    Cedulados
                  </li>
                  <li
                    className={
                      `clickable  border-bottom py-2 px-2 mb-2 ` +
                      (section === "empresasRASADEP" ? "active" : "")
                    }
                    onClick={() => setSection("empresasRASADEP")}
                  >
                    Empresas/RASADEP
                  </li>
                  <li>
                    <hr className="text-light bg-light" />
                  </li>
                  <li
                    className={
                      `clickable  border-bottom py-2 px-2 mb-2 ` +
                      (section === "companies" ? "active" : "")
                    }
                    onClick={() => setSection("companies")}
                  >
                    {t("Empresas Afiliadas")}
                  </li>
                  <li
                    className={
                      `clickable  border-bottom py-2 px-2 mb-2 ` +
                      (section === "users" ? "active" : "")
                    }
                    onClick={() => setSection("users")}
                  >
                    {t("Users")}
                  </li>
                  <li
                    className={
                      `clickable  border-bottom py-2 px-2 mb-2 ` +
                      (section === "settings" ? "active" : "")
                    }
                    onClick={() => setSection("settings")}
                  >
                    {t("Settings")}
                  </li>
                </ul>
              </div>
            </Col>
            <Col xs={12} md={8} lg={9}>
              <div className="mt-4" />
              {section === "users" && <AdminUsersComponent />}

              {section === "extranjerosHaitianos" && (
                <AdminExtranjerosHaitianosComponent />
              )}
              {section === "deportados" && (
                <AdminDeportadosComponent />
              )}
              {section === "dgii" && <AdminDGIIComponent />}

              {section === "complices" && <AdminComplicesComponent />}
              {section === "litigio" && <AdminLitigioComponent />}
              {/* {section === "detenidos" && <AdminDetenidos />} */}
              {/* {section === "centrosDetenidos" && <AdminCentrosDetenidos />} */}
              {section === "fichados" && <AdminFichadosComponent />}
              {section === "estructuras" && <AdminEstructuraComponent />}
              {section === "companies" && <AdminOrganizationsComponent />}

              {section === "desaparecidos" && <AdminDesaparecidosComponent />}
              {section === "extraditados" && <AdminExtraditadosComponent />}

              {section === "cedulados" && <AdminCeduladosComponent />}
              {section === "empresasRASADEP" && <AdminEmpresasRASADEPComponent />}
              {section === "settings" && <Settings />}
              {section === "identidades" && <AdminVerificarAntecedentes />}
              {section === "dashboard" && <AdminDashboardComponent />}
            </Col>
          </Row>
        </Container>
      </Modal.Body>
    </Modal>
  )
}

export default AdminContainerModal
